import * as jQueryModule from 'jquery'

// Handle both ESM/CJS jQuery shapes so global `$` is always callable.
const jQuery = ((jQueryModule as any).default || jQueryModule) as any
// Vite scopes modules, so attach shared globals for legacy scripts.
;(globalThis as any).$ = jQuery
;(globalThis as any).jQuery = jQuery
